<template>
	<div class="spread-user" :style="{ '--height': height, }">
		<div class="index-view-top">
			<div class="logo"><img src="../assets/768.png" alt=""></div>
			<div class="title">{{ $t("phone.tuiguan") }}</div>
			<van-icon name="ellipsis" size="28" style="opacity: 0" color="#ffffff" />
		</div>
		<div class="spread-scroll">
			<div class="spread-bannner">
				<div class="bannner-tips">
					<img src="../assets/3.png" alt="" />
					<p>{{ $t("spread.cumulative") }}{{ awardInfolist.directCount }}{{ $t("spread.people") }}，{{
							$t("spread.make")
					}}{{ awardInfolist.totalAward
}}，{{ $t("spread.Continue_to") }}！</p>
				</div>
				<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
					<van-swipe-item v-for="(item, index) in bannerLists" :key="index">
						<img class="banner-image" :src="baseUrl + item.img" alt="" @click="to(item.link)" />
					</van-swipe-item>
					<!-- <van-swipe-item><img class="banner-image" src="../assets/bannner.png" alt="" /></van-swipe-item> -->
				</van-swipe>
			</div>
			<div v-if="Invitecode.inviteUrl">
				<div class="invite-link">
					<div class="link-card">
						<div>
							<img class="card-image" src="../assets/21.png" alt="" />
							<p>{{ $t("spread.url") }}</p>
						</div>
						<div>
							<img class="dot" src="../assets/25.png" alt="" />
						</div>
						<div>
							<img class="card-image" src="../assets/22.png" alt="" />
							<p>{{ $t("spread.Friends_registered") }}</p>
						</div>
						<div>
							<img class="dot" src="../assets/25.png" alt="" />
						</div>
						<div>
							<img class="card-image" src="../assets/23.png" alt="" />
							<p>{{ $t("spread.money") }}</p>
						</div>
						<div>
							<img class="dot" src="../assets/25.png" alt="" />
						</div>
						<div>
							<img class="card-image" src="../assets/24.png" alt="" />
							<p>{{ $t("spread.Friends_deal") }}</p>
						</div>
					</div>
					<div class="link-button">
						<div class="qrCode">
							<div id="qrCode" ref="qrCodeDiv"></div>
						</div>
						<div class="copy-button">
							<div @click="toGetImage">
								<p>{{ $t("data.erweima") }}</p>
							</div>
							<div @click="copylink">
								<p>{{ $t("spread.copy_url") }}</p>
							</div>

						</div>
					</div>
				</div>
				<div class="my-group">
					<div class="group-title">
						<p>{{ $t("spread.my_group") }}</p>
						<p @click="$router.push('/performance')">{{ $t("spread.look") }}</p>
					</div>
					<div class="group-title-number">
						<p>{{ $t("spread.directCount") }}：</p>
						<div>
							<p>{{ awardInfolist.directCount }}</p>
						</div>
						<p>{{ $t("spread.group") }}：</p>
						<div>
							<p>{{ awardInfolist.teamCount }}</p>
						</div>
					</div>
					<div class="group-coin">
						<div>
							<p :class="type == 'USDT' ? 'coin-active' : ''" @click="type = 'USDT'">USDT</p>
							<p :class="type == 'TRX' ? 'coin-active' : ''" @click="type = 'TRX'">TRX</p>
						</div>
						<p @click="withdrawal">{{ $t("spread.Commission_withdrawal") }}</p>
					</div>
					<div v-for="(item, index) in awardInfolist.awardList" :key="index">
						<div v-if="type == item.coin">
							<div class="group-title-number">
								<p style="flex: 3">{{ $t("spread.historyAward") }}：</p>
								<div style="flex: 2">
									<p>{{ item.historyAward }}</p>
								</div>
								<p style="flex: 2">{{ $t("spread.yesterdayAward") }}：</p>
								<div style="flex: 2">
									<p>{{ item.yesterdayAward }}</p>
								</div>
							</div>
							<div class="group-title-number">
								<p style="flex: 3">{{ $t("spread.currentAward") }}：</p>
								<div style="flex: 2">
									<p>{{ item.currentAward }}</p>
								</div>
								<p style="flex: 2">{{ $t("spread.todayAward") }}：</p>
								<div style="flex: 2">
									<p>{{ item.todayAward }}</p>
								</div>
							</div>
						</div>

					</div>
				</div>
				<div class="my-invite">
					<div class="invite-title">{{ $t("spread.my_invite") }}</div>
					<div class="invite-code">
						<div>
							<p>{{ Invitecode.inviteCode }}</p>
						</div>
						<van-button color="#F8C007" style="background: unset" plain
							@click="copy(Invitecode.inviteCode)">
							{{ $t("spread.copy_invite") }}
						</van-button>
					</div>
				</div>
				<div class="my-invite">
					<div class="top-title">
						<p>{{ $t("spread.top_title") }}</p>
						<p>{{ $t("spread.update") }}</p>
					</div>
					<div class="invite-code">
						<van-cell-group inset style="margin: 0; width: 16rem">
							<van-field :disabled="awardInfolist.refInvite ? true : false" v-model="topInviteCode"
								:placeholder="tips" />
						</van-cell-group>
						<van-button color="#F8C007" style="background: unset; width: 4.5rem" plain @click="bindRefer()">
							{{
									$t("spread.binding")
							}}
						</van-button>
					</div>
				</div>
			</div>
			<div class="my-percent">
				<div class="percent-title">{{ $t("spread.Commission_ratio") }}</div>
				<div class="table">
					<div class="table-item-header">
						<div>
							<p>{{ $t("spread.level") }}</p>
						</div>
						<div>
							<p>{{ $t("spread.ratio") }}</p>
						</div>
					</div>
					<div class="table-item" v-for="(item, index) in awardRate" :key="index">
						<div>
							<p v-if="item.type == 1">{{ $t("spread.Directly_under") }}</p>
							<p v-else>{{ $t("spread.first") }}{{ item.type }}{{ $t("spread.levelone") }}</p>
						</div>
						<div>
							<p>{{ item.rate }}%</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabbar class="footer-tabbar" :tabbarType="'3'" @changeActiveStatus="changeActiveStatus"></tabbar>
	</div>
</template>

<script>
import QRCode from 'qrcodejs2';
import html2canvas from "html2canvas";
import tabbar from "../components/tabbar.vue";
import {
	bindRefer,
	carousel,
	info,
	awardInfo, awardRate
} from "@/utils/request";
import {
	BASEURL
} from "@/utils/http";
export default {
	components: {
		tabbar,
	},
	data() {
		return {
			Invitecode: [],
			bannerLists: [],
			baseUrl: "",
			account: '',
			awardInfolist: [],
			type: "USDT",
			height: '',//屏幕高度
			topInviteCode: '',//我的上级邀请码
			tips: '',
			awardRate: ''
		};
	},
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
	},
	mounted() {
		this.tips = this.$t("spread.nikname")
		this.baseUrl = BASEURL;
		this.getInfo()
	},
	beforeDestroy() {
		clearInterval(this.betInfoTimer)
	},
	methods: {
		to(url) {
			if (url != '') {
				location.href = url
			}
		},
		bindQRCode: function () {
			let a = window.location.href.replace('spread', 'register?code=')
			new QRCode(this.$refs.qrCodeDiv, {
				text: a + this.Invitecode.inviteCode,
				width: 160,
				height: 160,
				colorDark: "#000000", //二维码颜色
				colorLight: "#ffffff", //二维码背景色
				correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
			})
		},
		toGetImage() {
			//屏幕截图、保存图片到相册
			const qrcode = document.querySelector('#qrCode')
			const canvas = qrcode.querySelector('canvas')
			canvas.toBlob((blob) => {
				const timestamp = Date.now().toString();
				const a = document.createElement('a');
				document.body.append(a);
				a.download = `${timestamp}.png`;
				a.href = URL.createObjectURL(blob);
				a.click();
				a.remove();
			});
		},
		getInfo() {
			if (localStorage.getItem('token')) {
				this.betInfoTimer = setInterval(() => {
					awardInfo().then((res) => {
						if (res.code == "200") {
							this.awardInfolist = res.data
							if (res.data.refInvite) {
								this.topInviteCode = res.data.refInvite
							}
						}
					})
				}, 1000);
				info().then((res) => {
					if (res.code == "200") {
						this.Invitecode = res.data
						this.$nextTick(function () {
							this.bindQRCode();
						})
					}
				});
			}
			awardRate().then((res) => {
				if (res.code == "200") {
					this.awardRate = res.data
				}
			});
			carousel({
				type: "2"
			}).then((res) => {
				if (res.code == "200") {
					this.bannerLists = res.data;
				}
			});
		},
		copylink() {
			let a = window.location.href.replace('spread', 'register?code=')
			let url = a + this.Invitecode.inviteCode;
			let inputNode = document.createElement("input"); // 创建input
			inputNode.value = url; // 赋值给 input 值
			document.body.appendChild(inputNode); // 插入进去
			inputNode.select(); // 选择对象
			document.execCommand("Copy"); // 原生调用执行浏览器复制命令
			inputNode.className = "oInput";
			inputNode.style.display = "none"; // 隐藏
			this.$toast(this.$t("recharge.copy_success"));
		},
		getCarousel() {

		},
		withdrawal() {
			this.$router.push('/withdrawal?name=1')
		},
		copy(Invitecode) {
			let url = Invitecode;
			let inputNode = document.createElement("input"); // 创建input
			inputNode.value = url; // 赋值给 input 值
			document.body.appendChild(inputNode); // 插入进去
			inputNode.select(); // 选择对象
			document.execCommand("Copy"); // 原生调用执行浏览器复制命令
			inputNode.className = "oInput";
			inputNode.style.display = "none"; // 隐藏
			this.$toast(this.$t("recharge.copy_success"));
		},
		bindRefer() {
			var that = this;
			if (that.topInviteCode) {
				bindRefer({
					inviteCode: that.topInviteCode
				}).then((res) => {
					if (res.code == "200") {
						console.log(res)
					} else {
						that.$toast(res.msg);
					}
				});
			} else {
				that.$toast(this.$t("spread.nikname"));
			}

		},
		changeActiveStatus(item) {
			if (item == "1") {
				this.$router.push("/luckyHash");
			} else if (item == "2") {
				this.$router.push('/vip')
				// this.$toast(this.$t("transactiondetails.noopen"));
			} else if (item == "3") { } else if (item == "4") {
				this.$router.push("/help");
			} else if (item == "5") {
				if (!localStorage.getItem('token')) {
					this.$router.push("/");
					return
				}
				this.$router.push("/user");
			}
		},
		toBack() {
			this.$router.push("/user");
		},
	},
};
</script>

<style lang="scss" scoped>
/deep/.my-swipe .van-swipe-item {
	color: #fff;
	font-size: 1.25rem;
	text-align: center;
	background-color: #39a9ed;
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
	border: unset;
}

/deep/ .van-field__control {
	color: #ffffff !important;
}

.van-cell {
	background: #161414;
	//border-radius: 1.375rem;
}

.van-cell-group {
	background: #161414;
	border-radius: 1.375rem;
}

.spread-user {
	width: 100vw;
	height: var(--height);
	background: #0c0b0b;

	.spread-scroll {
		height: calc(var(--height) - 6.25rem);
		width: 100vw;
		overflow-x: hidden;
		overflow-y: scroll;
	}

	.my-percent {
		padding: 0 0.9375rem;

		.percent-title {
			font-size: 1rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			padding: 0.9375rem;
		}

		.table {
			width: 100%;
			border-radius: 0.625rem;
			border: 0.0625rem solid #272727;

			.table-item-header {
				height: 2.6875rem;
				display: flex;
				background: #161414;
				border-radius: 0.625rem 0.625rem 0px 0px;

				>div {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: center;

					>p {
						font-size: 0.875rem;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #ffffff;
					}
				}
			}

			.table-item {
				height: 2.6875rem;
				display: flex;
				background: #0c0b0b;
				border-top: 0.0625rem solid #272727;
				border-radius: 0px 0px 0.625rem 0.625rem;

				>div {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: center;

					>p {
						font-size: 0.75rem;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}

					>p:nth-child(2) {
						border-left: 0.0625rem solid #272727;
					}
				}
			}
		}
	}

	.my-invite {
		border-bottom: 0.375rem solid #060505;
		padding: 0 0.9375rem;

		.top-title {
			display: flex;
			align-items: center;
			padding: 0.9375rem;

			>p:nth-child(1) {
				font-size: 1rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
			}

			>p:nth-child(2) {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				padding-left: 0.9375rem;
			}
		}

		.invite-title {
			font-size: 1rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #ffffff;
			padding: 0.9375rem;
		}

		.invite-code {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-bottom: 0.9375rem;

			>div {
				width: 13.375rem;
				height: 2.6875rem;
				background: #161414;
				border-radius: 0.25rem;
				display: flex;
				align-items: center;

				>p {
					font-size: 0.8125rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					padding-left: 0.9375rem;
				}
			}
		}
	}

	.my-group {
		border-top: 0.375rem solid #060505;
		border-bottom: 0.375rem solid #060505;
		padding: 0 0.9375rem;

		.group-coin {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-bottom: 1rem;

			>div {
				display: flex;

				.coin-active {
					color: #ffc400 !important;
					border-bottom: 0.0625rem solid #ffc400 !important;
				}

				>p {
					display: block;
					margin-right: 3rem;
					font-size: 0.875rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					border-bottom: 0.0625rem solid #0c0b0b;
				}
			}

			>p {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
		}

		.group-title {
			display: flex;
			justify-content: space-between;
			padding: 0.9375rem 0 1.25rem;

			>p:nth-child(1) {
				font-size: 1rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
			}

			>p:nth-child(2) {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
		}

		.group-title-number {
			display: flex;
			align-items: center;
			padding: 0 0 0.9375rem;

			>p {
				display: block;
				flex: 1;
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				text-align: center;
			}

			>div {
				flex: 1;
				height: 2.375rem;
				border-radius: 0.25rem;
				border: 0.0625rem solid #272727;
				display: flex;
				align-items: center;

				>p {
					padding: 0 0.625rem;
					font-size: 0.8125rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #555555;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
				}
			}
		}
	}

	.invite-link {
		padding: 0.9375rem;

		.link-button {
			padding: 1.25rem 1.875rem 0.9375rem;

			.qrCode {
				width: 180px;
				height: 180px;
				background: #ffffff;
				border-radius: 0.625rem;
				margin: 0 auto;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.copy-button {
				display: flex;
				justify-content: space-between;
				padding-top: 1.5rem;

				>div {
					width: 40%;
					border-radius: 1.375rem;
					border: 0.0625rem solid #ffc400;
					display: flex;
					align-items: center;
					justify-content: center;
					height: 2rem;

					>p {
						font-size: 0.9375rem;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #ffc400;
					}
				}
			}
		}

		.link-card {
			display: flex;
			justify-content: space-around;
			padding: 1.5rem 0.75rem;
			background: #161414;
			border-radius: 0.625rem;

			>div {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				.dot {
					width: 1.5rem;
					height: 0.325rem;
				}

				.card-image {
					width: 1.375rem;
					height: 1.375rem;
					// width: 2.25rem;
					// height: 2.1875rem;
				}

				>p {
					font-size: 0.75rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;

				}
			}
		}
	}

	.spread-bannner {
		position: relative;

		.bannner-tips {
			position: absolute;
			z-index: 999;
			width: 100%;
			height: 2.1875rem;
			background: rgba(0, 0, 0, 0.3);
			padding: 0 0.9375rem;
			display: flex;
			align-items: center;

			>img {
				width: 1.4375rem;
				height: 1.4375rem;
				background: #ffffff;
				border-radius: 50%;
			}

			>p {
				font-size: 0.6875rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #ffffff;
				padding-left: 0.625rem;
			}
		}

		.my-swipe {
			z-index: 99;
			height: 9.375rem;

			.banner-image {
				width: 100%;
				height: 100%;
			}
		}
	}

	.index-view-top {
		height: 3.125rem;
		display: flex;
		align-items: center;
		padding: 0 0.9375rem;

		.logo {
			>img {
				display: block;
				width: 61.5px;
				height: 38px;
			}
		}

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #C08D4E;
			padding-left: .625rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/spread/spread.vue